import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useEnvironment } from 'hooks/useEnvironment';
import { SparkImageLoader } from 'sharedComponents/UI';

function SignInWithGoogleButton() {
  const { isDevelopment } = useEnvironment();
  const handleSignIn = async () => {
    window.open(
      process.env.REACT_APP_API_BASEURL +
        `auth/google/signIn${isDevelopment ? '?env=local' : ''}`,
      '_self'
    );
  };
  return (
    <Box display='flex' flexDirection='column' gap={2} marginBottom={1}>
      <Button
        fullWidth
        variant='outlined'
        onClick={handleSignIn}
        sx={{ gap: '1%', border: 'solid 1px #EEEEEEEE', padding: 1.6 }}
      >
        <SparkImageLoader
          src='/google.png'
          alt='google logo'
          width='4%'
          height='4%'
        />
        <Typography variant='body2' color='black' fontFamily='mont-semibold'>
          Continue with Google
        </Typography>
      </Button>
      <Box display='flex' alignItems='center'>
        <Box
          sx={{
            borderTop: (theme) => `1px solid ${theme.palette.borderColor}`,
            height: '0px',
            width: '100%',
          }}
        />
        <Typography sx={{ padding: '0 10px' }} variant='subtitle1'>
          OR
        </Typography>
        <Box
          sx={{
            borderTop: (theme) => `1px solid ${theme.palette.borderColor}`,
            height: '0px',
            width: '100%',
          }}
        />
      </Box>
    </Box>
  );
}

export default SignInWithGoogleButton;
